import { createApp } from 'vue'
import App from './App.vue'
import HelpMenu from './components/HelpMenu.vue'

createApp(App).mount('#app');
